// extracted by mini-css-extract-plugin
export default {"root":"root---WHJHt","userInfoLink":"userInfoLink---i0n57"};